import React from 'react';
import { MapPin } from 'lucide-react';

const BookingStepLocation = ({ formData, setFormData, setStep }) => (
  <div className="space-y-4">
    <h3 className="text-base sm:text-lg font-semibold text-stone-800">Choose Location</h3>
    <div className="grid gap-3">
      <button
        onClick={() => {
          setFormData({ ...formData, location: 'city_centre' });
          setStep(3);
        }}
        className={`p-4 sm:p-6 rounded-xl border-2 text-left transition-all ${
          formData.location === 'city_centre' 
            ? 'border-luxury-green bg-sage-50' 
            : 'border-stone-200 hover:border-sage-300'
        }`}
      >
        <div className="flex items-start gap-3">
          <MapPin className="text-luxury-green mt-1 flex-shrink-0" size={20} />
          <div>
            <p className="font-semibold text-stone-800 text-sm sm:text-base">City Centre - Dublin 1</p>
            <p className="text-xs sm:text-sm text-stone-500">19 Talbot Street, Opposite The Celt Pub</p>
            <p className="text-xs text-stone-400 mt-1">Near Connolly Station • Parking: Irish Life / Q-Park</p>
          </div>
        </div>
      </button>
      <button
        onClick={() => {
          setFormData({ ...formData, location: 'clarehall' });
          setStep(3);
        }}
        className={`p-4 sm:p-6 rounded-xl border-2 text-left transition-all ${
          formData.location === 'clarehall' 
            ? 'border-luxury-green bg-sage-50' 
            : 'border-stone-200 hover:border-sage-300'
        }`}
      >
        <div className="flex items-start gap-3">
          <MapPin className="text-luxury-green mt-1 flex-shrink-0" size={20} />
          <div>
            <p className="font-semibold text-stone-800 text-sm sm:text-base">Clarehall - Dublin 17</p>
            <p className="text-xs sm:text-sm text-stone-500">Clare Village Apartments, Donaghmede</p>
            <p className="text-xs text-luxury-green mt-1">Free parking • Shower facilities</p>
          </div>
        </div>
      </button>
    </div>
  </div>
);

export default BookingStepLocation;
